const DesirabilityStrings = {
  heading: 'Low buyer demand - consider awarding',
  whatsThis: "What's this?",
  shortDated: 'Short dated',
  listedRepeatedly: 'Listed repeatedly',
  competingInventory: 'Competing inventory',
  whatsThisUrl: 'https://spoileralert.kustomer.help/en_us/added-context-in-opportunities-SyUU3YKcfl',
};

export default DesirabilityStrings;
